import RestService from "./rest.service";


class SupportService {

  sendFeedback(data) {
    return new Promise(async (fnResolve, fnReject) => {
      RestService.post("app/kpi/support/feedback", data).then(
        (response) => {
          localStorage.setItem("date", response.data.expire);
          if (response.data.success) {
            fnResolve(response.data)
            return;
          }
          fnReject(response)
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new SupportService();
